import classNames from 'classnames'

import { BadgeSize, BadgeVariant } from './Badge.constants'

import * as styles from './Badge.module.css'

function Badge({
  className,
  size = BadgeSize.Small,
  variant = BadgeVariant.Theme,
}) {
  const badgeClassName = classNames(
    styles.badge,
    styles[variant],
    styles[size],
    className
  )

  return <span className={badgeClassName} />
}

export default Badge
